import { connect } from 'react-redux';

import ExecutionOptionsBar from '../../../components/common/ExecutionOptionsBar';
import { changeAdaptive, toggleAverage, toggleMedian, toggleTrend } from '../../../actions/chart';
import {
  changeRetentionComplexView,
  toggleRetentionAdaptive,
  toggleRetentionAverageLine,
  toggleRetentionMedianLine,
  toggleRetentionTrendLine,
} from '../../../actions/retention/retentionComplex';
import { getRetentionComplexOptions } from '../../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  options: getRetentionComplexOptions(state),
  selectStyle: { width: 200 },
  isRetention: true,
});

const mapDispatchToProps = (dispatch) => ({
  onChangeView: (view) => dispatch(changeRetentionComplexView(view)),

  toggleTrendLine: (e) => toggleTrend(e, () => dispatch(toggleRetentionTrendLine())),
  toggleAverageLine: (e) => toggleAverage(e, () => dispatch(toggleRetentionAverageLine())),
  toggleMedianLine: (e) => toggleMedian(e, () => dispatch(toggleRetentionMedianLine())),
  toggleAdaptive: (e) => changeAdaptive(e, () => dispatch(toggleRetentionAdaptive())),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutionOptionsBar);
